var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"search-panel__button-open",on:{"click":_vm.openFilter}},[_vm._v("\n    Выбрать недвижимость\n")])}
var staticRenderFns = []

export { render, staticRenderFns }